export function fromUnix(seconds: number): Date {
    return new Date(seconds * 1000);
}

export function formatDate(d: Date): string {
    return d.toLocaleDateString();
}

export function formatDateTime(d: Date): string {
    return `${formatDate(d)} ${d.toLocaleTimeString()}`;
}
